import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { cartFx } from 'utils';
import { _store } from '_Store';

interface StateProps {
	tabs: {
		path: string;
		icon?: string;
		icon2?: string;
		label?: string;
		component?: any;
	}[];
}
interface Props extends StateProps {}
const Tabs: React.FC<Props> = (props) => {
	const {
		__data: { cart, location, is_bottom_modal },
	} = _store.useState((s) => s);

	const history = useHistory();
	const lokation = useLocation();
	const [active, setActive] = React.useState(lokation.pathname.split('/')[1]);

	React.useEffect(() => {
		setActive(lokation.pathname.split('/')[1]);
	}, [lokation.pathname]);

	const navigate = (tab: (typeof props.tabs)[0]) => {
		window.scroll(0, 0);
		history.replace(tab.path);
	};
	return (
		<React.Fragment>
			{/* && props.tabs.map(t => t.path).includes(lokation.pathname) */}
			{location.address.iso && (
				<div
					id="Tabs"
					className={`justify-content-between ${is_bottom_modal.is_open ? 'd-none' : 'd-flex'}`}
				>
					{props.tabs.map((tab) => {
						const isActive = active === tab.path.split('/')[1];
						return (
							<div
								key={tab.path}
								className="text-center"
								onClick={() => navigate(tab)}
								style={{ position: 'relative' }}
							>
								<div>
									<img
										src={isActive ? tab.icon2 : tab.icon}
										alt={tab.path}
										style={{ opacity: isActive ? 1 : 0.6 }}
									/>
									{cart.items.length > 0 && tab.path === '/cart' && (
										<div className="cart_count">
											{cartFx.totalItems(cart.items)}
										</div>
									)}
								</div>
								<div
									className={`small mt-1 ${isActive ? 'primary' : 'text-muted'}`}
									style={{ opacity: isActive ? 1 : 0.6 }}
								>
									{tab.label}
								</div>
							</div>
						);
					})}
				</div>
			)}
		</React.Fragment>
	);
};

export default Tabs;

export const Offset = () => <div style={{ marginTop: '7vh' }} />;
